<template>
	<div>
		<div class='fair-switch' :class='isFair?"fair-switch-on":"fair-switch-off"' @click="switchFair">
		  <img :src='isFair?require("../assets/fair_switch_on.png"):require("../assets/fair_switch_off.png")' class='fair-switch-icon' />
		  <div class='fair-switch-text'>美颜</div>
		</div>
		
		<div>
		<div v-if="chosenPhoto.hasPrintPhoto" class='can-print-container'>
		  <div class='spec-name shorten-name'>
			  {{specInfo.specName}}
			</div>
			  <div class='image-dig'>
				<img :src="chosenPhotoSrc" mode="widthFix" class='preview'></img>
			  </div>
			  <div class='image-print'>
				<img :src="chosenPrintPhotoSrc" mode="widthFix" class='preview'></img>
			  </div>
			<div id='print-tip'>6寸纸质照片预览效果</div>
		</div>
		<div v-else class='cannot-print-container'>
		  <div class='spec-name'>
			  <span>{{specInfo.specName}}</span>
			</div>
			  <div class='image-dig'>
				<img :src="chosenPhotoSrc" mode="widthFix" class='preview'></img>
			  </div>
		</div>
		</div>
		<div id='color-container'>
			<div id='color-title'>选择背景色</div>
			<div id="bg-picker">
				<div v-for="(color, key) in bgChoices" :key="color.name">
					<input type="radio" :id="color.name" name="color" :value="key" v-model="bgColor">
					<label :for="color.name" >
					  <div :style="{backgroundColor:'#'+color.startColor}" :class="color.startColor=='ffffff'?'circle-white':'circle'">
					  </div>
					</label>
				</div>
			</div>
		</div>
		<div class="button-container" v-if="chosenPhoto.hasPrintPhoto">
		  <div id='ele' @click="submitDigitalOrder">
			  <img src="../assets/ele_price.png" class='button-icon' style='left: 16rpx;'/><span>保存电子照</span>
			</div>
			<div id='print' @click="print">
			  <span>立即冲印</span>
			</div>
		</div>
		<div class="button-container" v-else>
		  <div id='single-button' @click="submitDigitalOrder">
			  <img src="../assets/ele_price.png" class='button-icon' style='left: 20rpx;'/><span>保存无水印电子照</span>
			</div>
		</div>
		
		<mt-popup 
		v-model="mutipleVisible" 
		position="bottom">
			<div class='mutiple-container'>
			  <div class='mutiple-title'>
				支付选择                                              
				<div class='close-mutiple' @click="closeMutiple">×</div>
			  </div>
			  <div class='choice'>
				<div class='choice-container' :class='chosenWay=="single"?"chosen-container":"unchosen-container"' @click="chooseToPay('single')">

				  <div class='word-container'>
					<div class='price'>
					  <span class='price-character'>￥</span><span class='price-number'>2.99</span>
					</div>
					<div class='pay-tip'>
					  保存选中背景色电子照
					</div>
				  </div>

				  <img class='line' :src="chosenWay=='single'?require('../assets/pay_line_selected.png'):require('../assets/pay_line_normal.png')"/>
				  <img class='radio' :src="chosenWay=='single'?require('../assets/pay_bg_selected.png'):require('../assets/pay_bg_normal.png')"/>
				<!-- :src='item.open?require("../assets/up.png"):require("../assets/down.png")' -->
				</div>

				<div class='choice-container' :class='chosenWay=="mutiple"?"chosen-container":"unchosen-container"' @click="chooseToPay('mutiple')">
				  <div id='deceive'>87%用户的选择</div>

					<div class='word-container'>
					  <div class='price'>
						<span class='price-character'>￥</span><span class='price-number'>4.99</span> <span class='price-abolish'>原价￥{{originPrice}}</span>
					  </div>
					  <div class='pay-tip'>
						保存全部背景色电子照
					  </div>
					</div>

					<img class='line' :src="chosenWay=='mutiple'?require('../assets/pay_line_selected.png'):require('../assets/pay_line_normal.png')"/>
					<img class='radio' :src="chosenWay=='mutiple'?require('../assets/pay_bg_selected.png'):require('../assets/pay_bg_normal.png')"/>
			  
				</div>
			  </div>
			  <div class='button-container'>
				<div id='single-button' @click="payMutiple">
				  立即支付
				</div>
			  </div>
			</div>
		</mt-popup>
	</div>
</template>

<script>
	import PhotoContainer from "@/components/PhotoContainer";
	import { searchBySpecId,requestPayment,checkPaymentStatus} from "@/data/api";
	import { parseBgColor } from "@/utils/utils";
	import { mapState, mapMutations } from "vuex";
	import {alipay} from "@/utils/alipay";
	export default {
		components: {
			PhotoContainer
		},
		data() {
			return {
				bgChoices: [],
				mutipleVisible:false,
				isFair:true,
				visited: localStorage.getItem("visited"),
				chosenWay:'mutiple',
				originPrice:2.99,
				chosenPhoto:{}
			};
		},
		created() {
			const {
				specName,
				specId
			} = this.specInfo;
			ap.setNavigationBar({
				title: '选择背景'
			});
			this.$ba.trackPageview('chooseBackground');
			this.getBgColors(specId);
			this.chosenPhoto=this.processedPhoto;
			this.originPrice=(this.processedPhoto.final_pic_name.length*2.99).toFixed(2);
		},
		methods: {
			...mapMutations(["RECORD_SELECTED_BG"]),
			disappear() {
				this.$refs.cover.style.display = 'none';
				localStorage.setItem('visited', true);
			},
			submitDigitalOrder(){
				if(this.bgChoices.length==1){
					this.pay();
				}else{
					this.mutipleVisible=true;
				}
			},
			switchFair(){
				if(this.isFair){
					this.isFair=false;
					this.chosenPhoto=this.processedPhotoNoFair
				}else{
					this.isFair=true;
					this.chosenPhoto=this.processedPhoto
				}
			},
			closeMutiple(){
				this.mutipleVisible=false;
			},
			chooseToPay(e){
				this.chosenWay=e
			},
			pay() {
				ap.showLoading();
				const {
					serialNum,
					orderId
				} = this.orderInfo;
				requestPayment(
						0,
						this.orderInfo.orderId,
						this.openId || localStorage.openId,
						this.bgColor,
						0,
						1,
						null,
						this.isFair
					)
					.then((res) => {
						console.log(res)
						alipay(res.data.trade_no)
							.then(() => {
								const intervalId = setInterval(() => {
									checkPaymentStatus(this.orderInfo.orderId)
										.then(({
											data: {
												code,
												extract_code
											}
										}) => {
											if(code === 10000) {
												//支付成功
												clearInterval(intervalId);
												//track payment
												ap.hideLoading();
												this.$router.push({
													name: "orderList",
													query: {
														openId: this.openId,
														photoType:'digital'
													}
												});
											}
										})
										.catch(err => {
											ap.hideLoading();
											ap.showToast({
												content: err
											});
										});
								}, 1000);
							})
							.catch(err => {
								ap.hideLoading();
								if(err === "支付取消") {
									ap.showToast({
										content: err
									});
								} else {
									ap.confirm({
										title: '是否重新支付？',
										message: err
									}, (res) => {
										if(res.confirm) {
											this.pay();
										}
									});
								}
							});
					})
					.catch(err => {
						ap.hideLoading();
						ap.showToast({
							content: '无法连接服务器'
						});
					});
			},
			payMutiple(){
				if(this.chosenWay=='mutiple'){
					ap.showLoading();
					const {
						serialNum,
						orderId
					} = this.orderInfo;
					requestPayment(
							0,
							this.orderInfo.orderId,
							this.openId || localStorage.openId,
							this.bgColor,
							0,
							1,
							true,
							this.isFair
						)
						.then((res) => {
							console.log(res)
							alipay(res.data.trade_no)
								.then(() => {
									const intervalId = setInterval(() => {
										checkPaymentStatus(this.orderInfo.orderId)
											.then(({
												data: {
													code,
													extract_code
												}
											}) => {
												if(code === 10000) {
													//支付成功
													clearInterval(intervalId);
													//track payment
													ap.hideLoading();
													this.$router.push({
														name: "orderList",
														query: {
															openId: this.openId,
															photoType:'digital'
														}
													});
												}
											})
											.catch(err => {
												ap.hideLoading();
												ap.showToast({
													content: err
												});
											});
									}, 1000);
								})
								.catch(err => {
									ap.hideLoading();
									if(err === "支付取消") {
										ap.showToast({
											content: err
										});
									} else {
										ap.confirm({
											title: '是否重新支付？',
											message: err
										}, (res) => {
											if(res.confirm) {
												this.payMutiple();
											}
										});
									}
								});
						})
						.catch(err => {
							console.log(err)
							ap.hideLoading();
							ap.showToast({
								content: '无法连接服务器'
							});
						});
				}else{
					this.pay();
				}
			},
			getBgColors(specId) {
				searchBySpecId(specId).then(
					({
						data: {
							result: {
								background_color
							}
						}
					}) => {
						this.bgChoices = parseBgColor(JSON.parse(background_color));
					}
				);
			},

			print() {
				this.$router.push({
					name: "print",
					query: {
						watermarkPrintPhotoSrc: this.chosenPrintPhotoSrc,
						origin_pic_name: this.chosenPhoto.origin_pic_name,
						final_pic_name:this.chosenPhoto.final_pic_name[this.bgColor],
						print_pic_name:this.chosenPhoto.print_pic_name[this.bgColor]
					}
				});
			}
		},
		computed: {
			...mapState(["processedPhoto", "specInfo", "orderInfo", "price","processedPhotoNoFair"]),
			bgColor: {
				get() {
					return this.$store.state.bgColor;
				},
				set(val) {
					this.RECORD_SELECTED_BG(val);
				}
			},

			chosenPhotoSrc() {
				return this.chosenPhoto.watermarkPhotoSrc[this.bgColor];
			},
			chosenPrintPhotoSrc() {
				return this.chosenPhoto.watermarkPrintPhotoSrc[this.bgColor];
			}
		}
	};
</script>

<style lang="scss" scoped>
#single-button{
  width:94.667vw;
  height:45px;
  background:rgba(68,128,231,1);
  box-shadow:0px 5px 10px 0px rgba(68,128,231,0.25);
  border-radius:22.5px;
  line-height:45px;
  color: white;
  font-size: 16px;
  text-align: center;
  margin-left:2.6667vw;
  margin-top: 2.1333vw;
}
.button-icon{
  width: 59px;
  height: 45px;
  position: absolute;
  top: 8px;
  left:2.1333vw;
}
#ele{
  width:46.667vw;
  height:45px;
  line-height: 45px;
  background:rgba(68,128,231,1);
  box-shadow:0px 5px 10px 0px rgba(68,128,231,0.25);
  border-radius:22.5px;
  font-size:16px;
  color:rgba(255,255,255,1);
  margin: 8px 1.2vw 7px 2.1333vw;
  display: inline-block;
  text-align: center;
}
#print{
  width:46.667vw;
  height:45px;
  line-height: 45px;
  background:rgba(255,255,255,1);
  border-radius:22.5px;
  border:1px solid rgba(68,128,231,1);
  font-size:16px;
  color:rgba(68,128,231,1);
  margin: 8px 2.1333vw 7px 1.2vw;
  display: inline-block;
  text-align: center;
}

.can-print-container{
  padding-top: 19px;
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
}
.cannot-print-container{
  padding-top: 46px;
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
}
.spec-name{
  font-weight:bold;
  color:rgba(51,51,51,1);
  font-size:17px;
  margin-bottom: 10px;
}
.shorten-name{
  max-width: 53.33vw;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.preview {
  width: 100%;
  height: 100%;
  vertical-align: middle;
}
.can-print-container .image-dig{
  padding:6px;
  width: 37.333vw;
  background-color: white;
}
.can-print-container .image-print{
  margin-top: 5px;
  padding:6px;
  width: 37.333vw;
  background-color: white;
}
#print-tip{
  color:rgba(153,153,153,1);
  font-size: 12px;
  margin-top: 7px;
}
.cannot-print-container .image-dig{
  padding:6px;
  width: 53.333vw;
  background-color: white;
}
/* 美颜开关 */
.fair-switch{
  width: 70px;
  height: 30px;
  position: absolute;
  top:15px;
  right: 14px;
  border-radius:15.5px;
  background:rgba(255,255,255,1);
  box-shadow:0px 8px 20px 0px rgba(211,211,211,0.5);
}
.fair-switch-icon{
  height: 27px;
  width: 27px;
  position: absolute;
  top: 2px;
}
.fair-switch-text{
  font-size:14px;
  position: absolute;
  top: 6px;
}
.fair-switch-on .fair-switch-icon{
  right: 5px;
}
.fair-switch-on .fair-switch-text{
  left: 8px;
  color:rgba(255,192,56,1);
}
.fair-switch-off .fair-switch-icon{
  left:3px;
}
.fair-switch-off .fair-switch-text{
  right: 9px;
  color: #999999;
}

#color-container{
  width: 100vw;
  height: 140px;
  position: fixed;
  left: 0;
  bottom: 60px;
  background:rgba(255,255,255,1);
  display: flex;
  flex-direction: column;
  text-align: center;
  padding-top:22px;
  padding-bottom:30px;
}
#color-title{
  color:rgba(102,102,102,1);
  font-size: 12px;
  
}
#bg-picker {
		text-align: center;
		margin: 6.4032vw 0;
		display: flex;
		align-items: center;
		div {
			display: inline-block;
			margin: 0 auto;
		}
		input[type="radio"] {
			display: none;
			+label {
				color: #333;
				font-family: Arial, sans-serif;
				font-size: 14px;
				div {
					display: inline-block;
					width: 45px;
					height: 45px;
					cursor: pointer;
					border-radius: 50%;
				}
			}
			&:checked+label div{
				background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAYCAYAAACbU/80AAAAAXNSR0IArs4c6QAAAfVJREFUSA3VlllLA0EQhI33feOFIIIo4oGo6IP/Xw0qEdRnQSUeaLzvRK0vOGFsJpsDsmBBme3u2amamZ7FRF28qJfcnDguPomphP7EBbRWxFFP8DYuA+gsiazcR5YtiQMLErHi6KbjMDAvoQnUDDKKD2ttYFYik0aY8F5MirlaGpiRwJRoQfdvi1kKtTKA8DQCBi+Kt8QPl2/QQ5u4KnI/u8Ub8UusFmw5c1m8KrEpvvkFDKyLgyLPGBgQ02I1Jmg2Ot4CUVbODvwBR4Cojz4FayKGKgHXbDHwAtuN+HOglhdpVqHfFNsV94rsxLephcIxJZcDhU/lEH8M1PIpVpkRWTWiPjoUsDsXYpSJEdX5xNqvKl2O+INYFBhgckQ4exrSR6cCSD2EISVpYHubcspx1e7ESLhzpuEQoRlbzRtdijF2afKMpVdC4knl2dmScAYY6EywqhbzZo9ieuXqN0/PcHv89ykxx454TVAO7ARsHTsxLCLog6YkhwgrbxR9cJS7ojPp14o+28ZxAzmGDdE2pqvbX8T3xHNbKBXbHXDj6WDOnH8emlwy4jelGle2YhQzwETcYUxwx+12K1XAvp7OClGFD1EGmAoTnCkmQmMPlD8Rq0ZoUjsZn1K62po4Uu7YDq40LscAc76LHAdNiSHET8X/jx9/LVjBa4NM1gAAAABJRU5ErkJggg==");
				background-repeat: no-repeat; 
				background-position: center;
				background-size: 16px 12px;
			}
		}
	}
	.circle{
		border: 2px solid hsla(0, 0%, 100%, 0.3);
	}
	.circle-white{
		border: 2px solid hsla(0, 0%, 73%, 0.3);
	}
	
.mutiple-container{
  height: auto;
  background: #ffffff;
  width: 100vw;
}
.mutiple-title{
  font-size:12px;
  color:rgba(102,102,102,1);
  height: 59px;
  padding-top: 23px;
  padding-bottom: 19px;
  text-align: center;
  position: relative;
}
.close-mutiple{
  position: absolute;
  height: 0.32rem;
  line-height: 0.32rem;
  color: rgba(191,191,191,1);
  font-size: 32px;
  top: 10px;
  right: 10px;
}
.choice{
  display: flex;
  flex-direction: column;
  justify-content:space-between;
  align-items:center;
  height: 216px;
  padding-bottom:26px; 
  margin-bottom:60px;
}
.choice-container{
  position: relative;
  width:320px;
  height:90px;
  border-radius:4px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.unchosen-container{
  background:rgba(255,255,255,1);
  border:2px solid rgba(229,229,229,1);
}
.chosen-container{
  background:rgba(255,249,240,1);
  border:2px solid rgba(255,151,17,1);
}
#deceive{
  position:absolute;
  top: 0;
  right: -0.5px;
  width: 26.12vw;
  height: 22px;
  line-height: 22px;
  border-radius: 0 3px 0 4px;
  background: linear-gradient(to left,#FCCF4D,#F8B22A);
  text-align: center;
  font-size:11px;
  font-weight:500;
  color:rgba(255,255,255,1);
}
.word-container{
  margin-left: 27px;
  margin-right: 112px;
}
.pay-tip{
  font-size:12px;
  color:rgba(141,141,141,1);
}
.price{
  color: #FF9711;
}
.price-character{
  font-size: 15px;
}
.price-number{
  font-size: 23px;
}
.price-abolish{
  text-decoration: line-through;
  font-size:11px;
  margin-left: 6px;
}
.line{
  width: 3px;
  height: 28px;
}
.radio{
  width: 22px;
  height:22px;
  margin-left: 21px;
}
</style>